import {
  MappingIdentifier,
  RelationshipMapping,
} from 'src/containers/ProjectDiagram/types/data';
import { Model } from 'src/containers/ProjectDiagram/types/model';
import { isRelationshipMapping } from 'src/containers/ProjectDiagram/utils/data';
import { setDataProperty } from 'src/containers/ProjectDiagram/utils/setDataProperty';

/** sets `fromPrimaryIdentifier` or `toPrimaryIdentifier` on Relationship Mapping */
export const setRelationshipMappingPrimaryIdentifier =
  ({
    key,
    fromPrimaryIdentifier,
    toPrimaryIdentifier,
  }: {
    key: string;
    fromPrimaryIdentifier?: MappingIdentifier;
    toPrimaryIdentifier?: MappingIdentifier;
  }) =>
  (model: Model) => {
    const mapping = model.linkDataArray.find((link) => link.key === key);
    if (!mapping || !isRelationshipMapping(mapping)) {
      return;
    }

    if (fromPrimaryIdentifier) {
      setDataProperty<RelationshipMapping>(model)(
        mapping,
        'fromPrimaryIdentifier',
        fromPrimaryIdentifier
      );
    }

    if (toPrimaryIdentifier) {
      setDataProperty<RelationshipMapping>(model)(
        mapping,
        'toPrimaryIdentifier',
        toPrimaryIdentifier
      );
    }
  };
